export enum EnumSituacaoPedido {
    INVALIDO = 0,
    AGUARDANDO_CONFIRMACAO = 1,
    CONFIRMADO = 2,
    EM_PREPARO = 3,
    ENVIADO = 4,
    ENTREGUE = 5,
    CANCELADO = 6
}